import { CALL_API } from "../../middlewares/api";

export const AUTOGIRO_GET_PENDING_REQUEST = "AUTOGIRO_GET_PENDING_REQUEST";
export const AUTOGIRO_GET_PENDING_SUCCESS = "AUTOGIRO_GET_PENDING_SUCCESS";
export const AUTOGIRO_GET_PENDING_ERROR = "AUTOGIRO_GET_PENDING_ERROR";

export const AUTOGIRO_GET_COMPLETED_REQUEST = "AUTOGIRO_GET_COMPLETED_REQUEST";
export const AUTOGIRO_GET_COMPLETED_SUCCESS = "AUTOGIRO_GET_COMPLETED_SUCCESS";
export const AUTOGIRO_GET_COMPLETED_ERROR = "AUTOGIRO_GET_COMPLETED_ERROR";

export const AUTOGIRO_COMPLETE_REQUEST = "AUTOGIRO_GET_COMPLETE_REQUEST";
export const AUTOGIRO_COMPLETE_SUCCESS = "AUTOGIRO_GET_COMPLETE_SUCCESS";
export const AUTOGIRO_COMPLETE_ERROR = "AUTOGIRO_GET_COMPLETE_ERROR";

export const AUTOGIRO_ALL_PENDING_COMPLETE_REQUEST =
  "AUTOGIRO_ALL_PENDING_COMPLETE_REQUEST";
export const AUTOGIRO_ALL_PENDING_COMPLETE_SUCCESS =
  "AUTOGIRO_ALL_PENDING_COMPLETE_SUCCESS";
export const AUTOGIRO_ALL_PENDING_COMPLETE_ERROR =
  "AUTOGIRO_ALL_PENDING_COMPLETE_ERROR";

export const AUTOGIRO_ALL_PENDING_CLOSE_DIALOG =
  "AUTOGIRO_ALL_PENDING_CLOSE_DIALOG";

export const AUTOGIRO_CLEAR_AFTER_ACTION_CONFIRM_MSG =
  "AUTOGIRO_CLEAR_AFTER_ACTION_CONFIRM_MSG";

export const AUTOGIRO_TABLE_COMPLETED_CHANGE_PAGE =
  "AUTOGIRO_TABLE_COMPLETED_CHANGE_PAGE";
export const AUTOGIRO_TABLE_COMPLETED_CHANGE_FILTER =
  "AUTOGIRO_TABLE_COMPLETED_CHANGE_FILTER";

export const AUTOGIRO_TABLE_PENDING_CHANGE_PAGE =
  "AUTOGIRO_TABLE_PENDING_CHANGE_PAGE";
export const AUTOGIRO_TABLE_PENDING_CHANGE_FILTER =
  "AUTOGIRO_TABLE_PENDING_CHANGE_FILTER";

export function get_pending_autogiro() {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/loans/repayments/pending",
      authenticatedRequest: true,
      types: [
        AUTOGIRO_GET_PENDING_REQUEST,
        AUTOGIRO_GET_PENDING_SUCCESS,
        AUTOGIRO_GET_PENDING_ERROR,
      ],
    },
  };
}

export function complete_all_pending_autogiro() {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/loans/repayment/completeall",
      authenticatedRequest: true,
      method: "POST",
      types: [
        AUTOGIRO_ALL_PENDING_COMPLETE_REQUEST,
        AUTOGIRO_ALL_PENDING_COMPLETE_SUCCESS,
        AUTOGIRO_ALL_PENDING_COMPLETE_ERROR,
      ],
    },
  };
}

export function close_pending_dialog() {
  return (dispatch) => {
    dispatch({
      type: AUTOGIRO_ALL_PENDING_CLOSE_DIALOG,
    });

    dispatch(get_pending_autogiro());
  };
}

export function get_completed_autogiro() {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/loans/repayments/completed",
      authenticatedRequest: true,
      types: [
        AUTOGIRO_GET_COMPLETED_REQUEST,
        AUTOGIRO_GET_COMPLETED_SUCCESS,
        AUTOGIRO_GET_COMPLETED_ERROR,
      ],
    },
  };
}

export function complete_autogiro(order) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/loans/repayment/complete",
      authenticatedRequest: true,
      method: "POST",
      data: {
        CreditId: order.CreditId,
        OrderId: order.OrderId,
      },
      additionalData: order,
      types: [
        AUTOGIRO_COMPLETE_REQUEST,
        AUTOGIRO_COMPLETE_SUCCESS,
        AUTOGIRO_COMPLETE_ERROR,
      ],
    },
  };
}

export function clear_after_action_confirm_msg() {
  return { type: AUTOGIRO_CLEAR_AFTER_ACTION_CONFIRM_MSG };
}

export function change_autogiro_table_completed_page(page) {
  return {
    type: AUTOGIRO_TABLE_COMPLETED_CHANGE_PAGE,
    page,
  };
}

export function change_autogiro_table_completed_filter(key, value) {
  let filter = {};
  filter[key] = value;

  return {
    type: AUTOGIRO_TABLE_COMPLETED_CHANGE_FILTER,
    filter,
  };
}

export function change_autogiro_table_pending_page(page) {
  return {
    type: AUTOGIRO_TABLE_PENDING_CHANGE_PAGE,
    page,
  };
}

export function change_autogiro_table_pending_filter(key, value) {
  let filter = {};
  filter[key] = value;

  return {
    type: AUTOGIRO_TABLE_PENDING_CHANGE_FILTER,
    filter,
  };
}

export const AUTOGIRO_DELETE_REQUEST = "AUTOGIRO_DELETE_REQUEST";
export const AUTOGIRO_DELETE_SUCCESS = "AUTOGIRO_DELETE_SUCCESS";
export const AUTOGIRO_DELETE_ERROR = "AUTOGIRO_DELETE_ERROR";

export function cancel_payment(order) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/loans/repayment/delete",
      authenticatedRequest: true,
      method: "POST",
      data: {
        CreditId: order.CreditId,
        OrderId: order.OrderId,
      },
      additionalData: order,
      types: [
        AUTOGIRO_DELETE_REQUEST,
        AUTOGIRO_DELETE_SUCCESS,
        AUTOGIRO_DELETE_ERROR,
      ],
    },
  };
}
